import { SpanStatusCode } from '@opentelemetry/api';
import { EmeraldError } from 'src/common/api/emerald-error';
import { AbortedError } from 'src/common/api/extended-emerald-error';
import { withSpinner } from 'src/common/components/with-spinner/with-spinner';
import { OnlineItemActivationDeclined } from 'src/common/helpers/error-code';
import { createSpan, endSpan } from 'src/common/helpers/tracing-helper';
import { getInterventions } from 'src/interventions/business-logic/get-interventions';
import { CartStatus } from 'src/items-list/business-logic/service/enumerations/cart-status';
import { handleOnlineItemDeclinedOnCheckout } from 'src/online-items/business-logic/handle-online-item-decline';
import {
  isShowOwnBagPolicyOnPayment,
  showOwnBagPolicyDialog,
} from 'src/own-bag/business-logic/service/handle-own-bag-policy';
import { getCurrentXLRConfig } from 'src/xlr-configuration/xlr-config';
import { store } from '../../common/redux/configure-store';
import { TenderingActions } from '../../common/redux/reducers/tendering-reducer';
import { finishTransaction } from '../../home-page/business-logic/finish-transaction';
import { getTicketTotal } from '../../home-page/business-logic/get-ticket-total';
import { popupMessage } from '../../messages/business-logic/popup-message';

export const initiateTendering = async (): Promise<void> => {
  // Skip click balance due at tendering mode
  const cartStatus = store.getState().transaction.cartStatus;
  if (cartStatus === CartStatus.Tender) {
    return;
  }

  const span = createSpan('Checkout - Initiate Tendering');
  const isTransactionAndItemsExist =
    store.getState().transaction.transactionIdExists &&
    store.getState().itemList.ejItems.length > 0;

  if (isTransactionAndItemsExist && isShowOwnBagPolicyOnPayment()) {
    showOwnBagPolicyDialog({
      onAccept: initiateTendering,
      onCancel: () => {
        store.dispatch(TenderingActions.setIsOwnBagDisabled(true));
        initiateTendering();
      },
    });
  } else if (isTransactionAndItemsExist) {
    try {
      if (getCurrentXLRConfig().recallInterventionsSupported) {
        await getInterventions().catch(async err => {
          if (err instanceof AbortedError) {
            err = new EmeraldError('Intervention_Aborted_At_Checkout');
          }
          span.setStatus({
            code: SpanStatusCode.ERROR,
            message: 'Checkout - Initiate Tendering - Error',
          });
          throw err;
        });
      }
      await withSpinner(async () => {
        await getTicketTotal();
        store.dispatch(TenderingActions.setIsTendering(true));
        await withSpinner(() => finishTransaction(true));
      });
    } catch (err) {
      if (err.code === OnlineItemActivationDeclined) {
        const lineId = err.data?.[0].restrictedLines?.[0];
        return handleOnlineItemDeclinedOnCheckout(lineId);
      } else {
        popupMessage(err);
        span.setStatus({
          code: SpanStatusCode.ERROR,
          message: 'Checkout - Initiate Tendering - Error',
        });
      }
    }
  }
  endSpan(span);
};
